'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ObjectHelper = require('../../common/ObjectHelper.js');

var marker;
var buildMarker = function buildMarker(map, maps, lat, lng) {
  marker = new maps.Marker({
    position: {
      lat: lat,
      lng: lng
    },
    map: map
  });
};
var resetMarker = function resetMarker(lat, lng) {
  if (ObjectHelper.isBlank(marker)) {
    throw new Error('Marker is not initialized! Initialize by calling buildMarker().');
  }

  marker.setPosition({
    lat: lat,
    lng: lng
  });
};

exports.buildMarker = buildMarker;
exports.resetMarker = resetMarker;
